var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Videophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 41h4v4h-4v-4zm0-4h4v-4h-4v4zm-24-9h28V16H24v12zm16 17h4v-4h-4v4zm4-12h-4v4h4v-4zm4.23 20l2.88 2.75L48.27 58l-1.65-2L45 58h-1.89l-1.65-2-1.62 2h-3.55a6.2 6.2 0 11.32-5h11.62zM30 55.13a1.7 1.7 0 10-1.69 1.7 1.69 1.69 0 001.69-1.7zM32 45h4v-4h-4v4zm4-12h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm32-16.75v43.5A9.25 9.25 0 0150.75 69h-25.5A9.25 9.25 0 0116 59.75v-43.5C16 10.8 19.39 7 24.25 7h26.5A9.25 9.25 0 0160 16.25zm-4 0A5.25 5.25 0 0050.75 11h-26.5C21.12 11 20 13.71 20 16.25v43.5A5.25 5.25 0 0025.25 65h25.5A5.26 5.26 0 0056 59.75v-43.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Videophone.fa86727f.svg";
export { SvgG1Videophone as ReactComponent };